<template>
  <div class="app-container">
    <NavTitle :title="title" />
    <div class="order-search-box">
      <div class="order-search-content">
        <div class="order-search-item">
          <div class="order-search-item-label">日期范围</div>
          <div class="order-search-item-input">
            <el-date-picker
              v-model="queryParam.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 100%"
              :editable="false"
              size="mini"
            ></el-date-picker>
          </div>
        </div>
        <div class="order-search-item">
          <div class="order-search-item-label">机构名称</div>
          <div class="order-search-item-input">
            <el-input
              v-model="queryParam.enterpriseName"
              placeholder="请输入"
              style="width: 100%"
              size="mini"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="order-search-item">
          <div class="order-search-item-label">订单编号</div>
          <div class="order-search-item-input">
            <el-input
              v-model="queryParam.orderNumber"
              placeholder="请输入"
              style="width: 100%"
              size="mini"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
        </div>
        <div class="order-search-item">
          <div class="order-search-item-label">发票状态</div>
          <div class="order-search-item-input">
            <el-select
              v-model="queryParam.invoiceState"
              placeholder="请选择"
              clearable
              size="mini"
              style="width: 100%"
            >
              <el-option
                v-for="item in filterData.invoiceState"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
      <div class="order-search-button">
        <el-button type="primary" size="mini" @click="handleSearch"
          >查询</el-button
        >
        <el-button plain size="mini" @click="handleReset">重置</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="table-button">
        <el-button type="primary" size="mini" @click="handleCreateOrder">
          <i class="el-icon-plus"></i>
          创建订单
        </el-button>
      </div>
      <div class="table-tip-box">
        <div>
          <i class="el-icon-s-opportunity"></i>
          提示：
        </div>
        <div>
          <div style="margin-bottom: 8px">
            1、我们将在您申请发票后，10个工作日内处理、开具、烦请耐心等待。
          </div>
          <div>
            2、电子发票其法律效力、基本用途和基本使用规定等与纸质增值税普通发票相同，可以报销、入账，属于合法的有效凭证。
          </div>
        </div>
      </div>
      <div class="table-d">
        <el-table
          ref="workTableRef"
          :data="tableList"
          stripe
          :header-cell-style="{
            background: '#F0F3F7',
            color: '#2a354e',
            fontWeight: 400,
          }"
          height="450"
          highlight-current-row
          :row-key="'id'"
          @row-click="handleRowClick"
          v-loading="loading"
          size="mini"
        >
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <span
                v-if="scope.row.hasInvoiceApply"
                :class="[
                  'table-status',
                  {
                    blue: scope.row.invoiceEnabled,
                    gray: !scope.row.invoiceEnabled,
                  },
                ]"
                style="margin-right: 15px"
                @click="handleApplyInvoice(scope.row)"
                >申请发票</span
              >
              <span
                v-if="scope.row.hasInvoice"
                :class="[
                  'table-status',
                  {
                    blue: scope.row.invoiceEnabled,
                    gray: !scope.row.invoiceEnabled,
                  },
                ]"
                @click="handleInvoiceDetail(scope.row)"
                >发票详情</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="enjoyPaymentName"
            label="开通机构"
            width="250"
          />
          <el-table-column prop="invoiceState" label="发票状态" width="150">
            <template slot-scope="scope">
              <span
                :class="[
                  'table-status',
                  {
                    green: scope.row.invoiceState == '已开票',
                  },
                ]"
                >{{ scope.row.invoiceState }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNumber"
            label="订单编号"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="paymentOrderName"
            label="产品名称"
            width="250"
          />
          <el-table-column
            prop="mainPaymentName"
            label="支付机构"
            width="250"
          />
          <el-table-column
            prop="paymentTime"
            label="支付时间"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="paymentValidDate"
            label="服务有效期"
            width="150"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="actualPriceStr"
            label="支付金额"
            width="150"
            :show-overflow-tooltip="true"
          />
        </el-table>
      </div>
      <div class="table-page">
        <div class="table-page-index">当前 {{ paging.index }} 页</div>
        <el-pagination
          :current-page="paging.index"
          :page-size="paging.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <Purchase ref="PurchaseRef" @successPay="fetchList" />
    <ApplyInvoice ref="ApplyInvoiceRef" @submit="fetchList" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Purchase from "@/components/Purchase";
import ApplyInvoice from "./components/applyInvoice.vue";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "MyOrder",
  components: {
    Purchase,
    ApplyInvoice,
    NavTitle,
  },
  computed: {
    ...mapGetters(["enterpriseId"]),
  },
  data() {
    return {
      title: ["我的订单"],
      barcode: "",
      paging: {
        index: 1,
        size: 100,
      },
      total: 0,
      tableList: [],
      selectedRow: null,
      filterData: {},
      queryParam: {
        date: [],
        enterpriseName: "",
        orderNumber: "",
        invoiceState: "",
      },
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    handleInvoiceDetail(row) {
      if (!row.invoiceEnabled) return;
      window.open(row.filePath, "_blank");
    },
    handleApplyInvoice(row) {
      if (!row.invoiceEnabled) return;
      this.$refs.ApplyInvoiceRef.show(row);
    },
    handleCreateOrder() {
      this.$refs.PurchaseRef.show(this.enterpriseId);
    },
    handleSearch() {
      this.paging.index = 1;
      this.fetchList();
    },
    handleReset() {
      this.queryParam.date = [];
      this.queryParam.enterpriseName = "";
      this.queryParam.orderNumber = "";
      this.queryParam.invoiceState = "";
    },
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleCurrentChange(index) {
      this.paging.index = index;
      this.fetchList();
    },
    async fetchList() {
      this.loading = true;
      const { data: tableList, extended } = await this.$api.order.GetOrderList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = tableList;
      this.total = extended.paging.total;
      this.loading = false;
    },
    async fetchData() {
      this.loading = true;
      const { data: filtersData } = await this.$api.order.GetOrderListFilter();
      this.filterData = filtersData;
      const { data: tableList, extended } = await this.$api.order.GetOrderList({
        ...this.queryParam,
        paging: this.paging,
      });
      this.tableList = tableList;
      this.total = extended.paging.total;
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
